import React from 'react';
import {
  withStyles,
  IconButton,
  Backdrop,
  Dialog,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ReactMarkdown from 'react-markdown';
// import { marked } from 'marked';
// import html2pdf from 'html2pdf.js';
import { STATIC_CONTENT } from '../../../../../assets/staticContent';
import styles from './readmeDialogStyle';
import CustomTheme from './readmeDialogTheme';
// import nihLogo from './assets/dh_nih_logo.png';
// import { createFileName } from './utils';
import PdfDownloadIcon from './assets/Download_PDF.svg';

// const date = new Date().toLocaleString('en-us', { month: 'long', year: 'numeric', day: 'numeric' });

/** download pdf of marked down file
   * 1.convert or generate html element of marked object
   * 2. uses html2pdf library to convert html to pdf
   * all the html style from marked down file will be reflected on PDF
   */
// export const downloadMarkdownPdf = async (title, content) => {
//   const bodyHtml = marked(content);
//   const bodyHtmlWithPageBreaks = bodyHtml.replace(
//     /<!-- PAGE BREAK -->/g,
//     '<div class="page-break"></div>',
//   );

//   const fullHtml = `
//     <html>
//       <head>
//         <style>
//           body { font-family: 'Source Sans Pro', sans-serif; font-size: 12pt; }
          
//           /* This rule prevents elements from being split in half. */
//           p, li, h3, blockquote, pre, table, tr {
//             page-break-inside: avoid;
//           }

//           /* --- THE FIX for Orphan Headers --- */
//           /* The !important flag gives this rule higher priority, forcing the header
//              to stay with the content that follows it. */
//           h3 {
//             page-break-after: avoid !important;
//           }
//           /* ------------------------------------ */

//           .page-break {
//             page-break-after: always;
//           }
//           hr {
//             border: none;
//             height: 3px;
//             color: #173554;
//             background-color: #173554;
//           }
//         </style>
//       </head>
//       <body>
//         <img src='${nihLogo}' height="50px" width="384px"  alt='logo' />
//         <hr />
//         <br>
//         <span style='color: #4D6787; font-size: 23px; font-family: Nunito Light'>${title}</span>
//         ${bodyHtmlWithPageBreaks}
//       </body>
//     </html>
//   `;

//   const fileName = createFileName('GC-SELECTED-FILES-CART-README', 'pdf');
//   const options = {
//     margin: [0.5, 0.5, 1.0, 0.5],
//     filename: fileName,
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: {
//       dpi: 192,
//       scale: 4,
//       letterRendering: true,
//       useCORS: true,
//     },
//     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
//     pagebreak: {
//       mode: ['css', 'legacy'],
//     },
//   };

//   html2pdf()
//     .set(options)
//     .from(fullHtml)
//     .toPdf()
//     .get('pdf')
//     .then((pdf) => {
//       const totalPages = pdf.internal.getNumberOfPages();
//       const pageSz = pdf.internal.pageSize;
//       const pgHeight = pageSz.getHeight();
//       const pgWidth = pageSz.getWidth();

//       for (let i = 1; i <= totalPages; i += 1) {
//         pdf.setPage(i);
//         pdf.setFont('Source Sans Pro,sans-serif');
//         pdf.setFontSize(8);
//         pdf.setTextColor(0);
//         pdf.text(pgWidth - 2.3, pgHeight - 0.5, `${date}     |      ${i}`);
//         pdf.text(pgWidth - 8, pgHeight - 0.5, 'GENERAL.DATACOMMONS.CANCER.GOV/#/FileCentricCart');
        
//         pdf.setDrawColor('#173554');
//         pdf.setLineWidth(0.02);
//         pdf.line(0.5, pgHeight - 0.7, pgWidth - 0.5, pgHeight - 0.7);
//       }
//     })
//     .save();
// };

const ReadMeDialogComponent = ({
  classes,
  display,
  displayReadMeDialog,
  content,
  title,
}) => {
  if (!content) {
    return (<></>);
  }

  const README_PDF_URL = STATIC_CONTENT.cart.README_PDF;
  const downloadFileName = README_PDF_URL.substring(README_PDF_URL.lastIndexOf('/') + 1);

  return (
    <CustomTheme>
      <Dialog
        classes={{
          paper: classes.dialogPaper,
        }}
        open={display}
        onClose={displayReadMeDialog}
        maxWidth="md"
        className={classes.dialogBox}
        BackdropProps={{
          timeout: 500,
        }}
        BackdropComponent={Backdrop}
      >
        <div className={classes.titleContent}>
          <div className={classes.title}>
            <span>
              {title}
            </span>
          </div>
          <div item xs={1} className={classes.closeBtn}>
            <Button
              className={classes.downloadBtn}
              href={README_PDF_URL}
              download={downloadFileName}
              target="_blank"
              rel="noopener noreferrer"
              component="a"
            >
              <img
                src={PdfDownloadIcon}
                alt="pdf download icon"
                className={classes.downloadIcon}
              />
            </Button>
            <IconButton
              className={classes.closBtnContainer}
              onClick={displayReadMeDialog}
            >
              <CloseIcon
                fontSize="small"
                className={classes.closeBtn}
              />
            </IconButton>
          </div>
        </div>
        <div
          className={classes.content}
          id="readMe_content"
        >
          <ReactMarkdown>
            {content.replace(/<!-- PAGE BREAK -->/g, '')}
          </ReactMarkdown>
        </div>
      </Dialog>
    </CustomTheme>
  );
};

export default withStyles(styles)(ReadMeDialogComponent);
